import React, { useEffect } from "react"

const MapFunctionality = props => {
    
    return (
        <div>
          <img className="map-mobile"
            src="https://images.ctfassets.net/zo243s55pyir/505Pe91RsMqrYqBwnOmnKS/695b867c38e7b910ce36fe654f853c17/india-map-mobile.png" 
            alt="India Map"
          />
          <img className="map-desktop"
            src="https://images.ctfassets.net/zo243s55pyir/7p4d5Pjjr62du2EdzjHoeh/565c8e1319bd54f57aa4d8d463be15fd/india-map.png" 
            alt="India Map" 
            useMap="#india-map" 
          />
          <map name="india-map">
            <span className="tooltip tooltip1">
            <area target="" alt="Baddi" title="Baddi" href="" coords="248,132,17" shape="circle" />
            <span className="tooltiptext tooltiptext1">Baddi</span></span>
            <span className="tooltip tooltip2">
            <area target="" alt="New Delhi" title="New Delhi" href="" coords="222,151,16" shape="circle" />
            <span className="tooltiptext tooltiptext2">New Delhi</span></span>
            <span className="tooltip tooltip3">
            <area target="" alt="Malanpur" title="Malanpur" href="" coords="246,260,15" shape="circle" />
            <span className="tooltiptext tooltiptext3">Malanpur</span></span>
            <span className="tooltip tooltip4">
            <area target="" alt="Kolkata" title="Kolkata" href="" coords="459,338,16" shape="circle" />
            <span className="tooltiptext tooltiptext4">Kolkata</span></span>
            <span className="tooltip tooltip5">
            <area target="" alt="Thane" title="Thane" href="" coords="186,381,17" shape="circle" />
            <span className="tooltiptext tooltiptext5">Thane</span></span>
            <span className="tooltip tooltip6">
            <area target="" alt="Mumbai" title="Mumbai" href="" coords="161,406,17" shape="circle" />
            <span className="tooltiptext tooltiptext6">Mumbai</span></span>
            <span className="tooltip tooltip7">
            <area target="" alt="Induri" title="Induri" href="" coords="201,426,17" shape="circle" />
            <span className="tooltiptext tooltiptext7">Induri</span></span>
            <span className="tooltip tooltip8">
            <area target="" alt="Sri City" title="Sri City" href="" coords="265,517,18" shape="circle" />
            <span className="tooltiptext tooltiptext8">Sri City</span></span>
            <span className="tooltip tooltip10">
            <area target="" alt="Chennai" title="Chennai" href="" coords="279,553,16" shape="circle" />
            <span className="tooltiptext tooltiptext10">Chennai</span></span>
        </map>
        </div>
    )
}

export default MapFunctionality